var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEverlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 14,
    viewBox: "0 0 148 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500244 13.908V0.0921631H11.5597V2.84852H3.2566V5.60488H8.76932V8.39527H3.2566V11.1516H11.5597V13.908H0.500244Z",
    fill: "var(--klothed-textColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5353 13.9077L17.9885 0.0919189H20.9491L24.9305 9.92633L28.8438 0.0919189H31.8043L26.2916 13.9077H23.5353Z",
    fill: "var(--klothed-textColor)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9883 13.9077V0.0919189H50.0477V2.84828H41.7446V5.60463H47.2574V8.39502H41.7446V11.1514H50.0477V13.9077H38.9883Z",
    fill: "var(--klothed-textColor)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2823 13.9081L68.3086 7.85093C69.6382 7.14511 70.455 5.74872 70.4184 4.24384C70.4554 3.13343 70.023 2.05879 69.2274 1.28331C68.4395 0.506444 67.3733 0.0775019 66.2669 0.092289H57.9978V13.9081H60.7542V8.39539H65.5863L67.3898 13.9081H70.2823ZM66.2701 5.6045H60.7573V2.81412H66.2701C67.0406 2.81412 67.6652 3.43876 67.6652 4.20931C67.6755 4.58132 67.527 4.94013 67.2569 5.19615C66.9973 5.46102 66.6409 5.60851 66.2701 5.6045Z",
    fill: "var(--klothed-textColor)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6306 13.9077V0.0919189H81.387V11.1514H88.2949V13.9077H78.6306Z",
    fill: "var(--klothed-textColor)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2126 11.1514H104.896L106.018 13.9077H108.979L103.432 0.0919189H100.676L95.1292 13.9077H98.0897L99.2126 11.1514ZM102.035 4.07555L103.77 8.39725H100.299L102.035 4.07555Z",
    fill: "var(--klothed-textColor)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.113 0.0919189V13.9077H125.357L118.449 4.71988V13.9077H115.693V0.0919189H118.449L125.357 9.27978V0.0919189H128.113Z",
    fill: "var(--klothed-textColor)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.44 13.9077V0.0919189H147.5V2.84828H139.197V5.60463H144.71V8.39502H139.197V11.1514H147.5V13.9077H136.44Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEverlane);
export default __webpack_public_path__ + "static/media/logo-everlane.bffac8f4415127b68411647fa8f6e504.svg";
export { ForwardRef as ReactComponent };